import { createEntityStore } from './entityStore';

/**
 * Maps protocol entity names to trusted Dexie store names.
 *
 * Protocol names are singular while local table names are plural. Keeping the
 * mapping explicit prevents external input from selecting arbitrary tables.
 */
export const ENTITY_TABLES = Object.freeze({
  task: 'tasks',
  work_interval: 'work_intervals'
});

/**
 * Creates the explicit allowlist of synchronized entity handlers.
 *
 * The registry avoids deriving table names from external entity_type values,
 * so unsupported protocol entities cannot select arbitrary Dexie tables.
 *
 * @param {Object} database - Open Dexie database instance.
 * @returns {Object} Entity-type to persistence-handler mapping.
 */
export const createEntityStoreRegistry = (database) =>
  Object.freeze(
    Object.fromEntries(
      Object.entries(ENTITY_TABLES).map(([entityType, tableName]) => [
        entityType,
        createEntityStore(database, tableName)
      ])
    )
  );

/**
 * Resolves one supported entity handler.
 *
 * @param {Object} registry - Explicit entity handler registry.
 * @param {string} entityType - Protocol entity type.
 * @returns {Object|null} Handler or null when unsupported.
 */
export const getEntityStore = (registry, entityType) =>
  registry[entityType] || null;
